import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g84ckd3mt5: FaireBrandEntity = {
  token: "b_g84ckd3mt5",
  type: "brand",
  name: "PAWPAWwholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/b0e32b98e7617ef4a5ed7039e16bd72f6dcafdc659ab904054be2df3a9a79d72.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f9ca15f45d65efdfda897f4505376607d10baaa65b7bea32f263b89cfcc5cb2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b0e32b98e7617ef4a5ed7039e16bd72f6dcafdc659ab904054be2df3a9a79d72.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f9ca15f45d65efdfda897f4505376607d10baaa65b7bea32f263b89cfcc5cb2.png",
  location: "Anaheim, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.1,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "🐾 PawPaw Wholesale — Premium Pet Essentials for Every Shop\n\nAt PawPaw Wholesale, we believe that pets deserve the same level of care, quality, and style as the people who love them. Born out of a genuine passion for animals and thoughtful retail, our mission is to provide independent retailers, boutiques, and online sellers with beautifully made, dependable pet products that bring joy to pets and their humans alike.\n\nFrom timeless leather collars to plush toys, elevated feeding bowls, and cozy beds, every item in our collection is hand-selected for quality, function, and design appeal. We focus on modern, clean aesthetics and durable materials, making our products perfect for shops that value both style and substance.\n\nAs a trusted wholesale partner, PawPaw Wholesale is dedicated to:\n\n🐶 Consistent Quality — Products that look beautiful and last.\n\n🛍️ Retailer-Friendly Service — Smooth ordering, quick shipping, and reliable stock.\n\n✨ Timeless Design — Neutral tones, elegant textures, and thoughtful details that fit effortlessly into any store.\n\nWhether you run a pet boutique, concept store, or online platform, we’re here to help you offer your customers the very best for their furry friends. Together, let’s make every wag and purr a little more special.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.306Z",
    importedBy: "entity-db-cli",
  },
};
